import React, {
  useState,
  useEffect,
  useMemo,
  useReducer,
  useContext,
} from "react";
import { useTable, usePagination, useSortBy, actions } from "react-table";
import { useQuery } from "react-query";
import { ChoiceGroup, Dropdown, Icon, PrimaryButton } from "@fluentui/react";
import { getErrorList } from "../../service/MasterService";
import { Link, useNavigate } from "react-router-dom";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import "./ListViewTableStyles.css";

import { t } from "i18next";

import { useTranslation } from "react-i18next";
import { AuthRoutes, USERTYPES } from "../../constants/Constants";
import userContext from "../../context/users/UserContext";
import TablePagination from "./TablePagination";
import loaderContext from "../../context/loader/LoaderContext";

// import customStyles from './modality.module.css';
// import UsersFilter  from "./UsersFilter"

var initialState = {
  queryPageIndex: 0,
  queryPageSize: 10,
  totalCount: 0,
  queryPageFilter: { payload: {} },
  queryPageSortBy: [],
};

const PAGE_CHANGED = "PAGE_CHANGED";
const PAGE_SIZE_CHANGED = "PAGE_SIZE_CHANGED";
const PAGE_SORT_CHANGED = "PAGE_SORT_CHANGED";
const PAGE_FILTER_CHANGED = "PAGE_FILTER_CHANGED";
const TOTAL_COUNT_CHANGED = "TOTAL_COUNT_CHANGED";

const reducer = (state, { type, payload }) => {
  switch (type) {
    case PAGE_CHANGED:
      return {
        ...state,
        queryPageIndex: payload,
      };
    case PAGE_SIZE_CHANGED:
      return {
        ...state,
        queryPageSize: payload,
      };
    case PAGE_SORT_CHANGED:
      return {
        ...state,
        queryPageSortBy: payload,
      };
    case PAGE_FILTER_CHANGED:
      return {
        ...state,
        queryPageFilter: { payload },
      };
    case TOTAL_COUNT_CHANGED:
      return {
        ...state,
        totalCount: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
};

const ListViewTable = (props) => {
  const { ref, setLoaderRunning } = useContext(loaderContext);

  if (props.initialState != null || props.initialState != undefined) {
    initialState.queryPageFilter.payload = props.initialState;
  }
  const [keyword, setKeyword] = useState("");
  const [useFilter, setUseFilter] = useState(false);

  const [t, i18n] = useTranslation();

  // Could be used in future
  const onClickFilterCallback = (filter) => {
    if (filter.trim() === "") {
      alert("Please enter a keyword to search!");
      return;
    }
    if (filter === keyword) {
      alert("No change in search");
      return;
    }
    setUseFilter(true);
    setKeyword(filter);
  };

  const [
    {
      queryPageIndex,
      queryPageSize,
      totalCount,
      queryPageFilter,
      queryPageSortBy,
    },
    dispatch,
  ] = useReducer(reducer, initialState);

  const { isLoading, error, data, isSuccess } = useQuery(
    [
      "auditlog",
      queryPageIndex,
      queryPageSize,
      queryPageFilter,
      queryPageSortBy,
    ],
    () => {
      // console.log(queryPageIndex+" "+queryPageSize);
      return props.fetchFunction(
        queryPageIndex,
        queryPageSize,
        queryPageFilter,
        queryPageSortBy
      );
    },
    {
      keepPreviousData: true,
      staleTime: Infinity,
      cacheTime:
        props.cacheTime == null || props.cacheTime == undefined
          ? 10000
          : props.cacheTime,
    }
  );

  const totalPageCount = Math.ceil(totalCount / queryPageSize);
  const columns = props.columns;
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    pageCount,
    pageOptions,
    gotoPage,
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    setPageSize,
    setSortBy,
    state: { pageIndex, pageSize, sortBy },
  } = useTable(
    {
      columns,
      disableSortRemove: true,
      defaultCanSort: true,
      data: data?.results || [],
      initialState: {
        pageIndex: queryPageIndex,
        pageSize: queryPageSize,
        sortBy: queryPageSortBy,
        hiddenColumns:
          props.hiddenColumns == undefined || props.hiddenColumns == null
            ? []
            : props.hiddenColumns,
      },
      manualPagination: true,
      manualSortBy: true,
      pageCount: data ? totalPageCount : null,
      autoResetSortBy: false,
      autoResetExpanded: false,
      autoResetPage: false,
    },
    useSortBy,
    usePagination
  );
  const manualPageSize = [];

  useEffect(() => {
    dispatch({ type: PAGE_CHANGED, payload: pageIndex });
  }, [pageIndex]);

  useEffect(() => {
    dispatch({ type: PAGE_SIZE_CHANGED, payload: pageSize });
    gotoPage(0);
  }, [pageSize, gotoPage]);

  useEffect(() => {
    console.log("--- Sort by changing ----");
    console.log(sortBy);
    //setSortBy([{id:'first_name',desc:true}]);
    dispatch({ type: PAGE_SORT_CHANGED, payload: sortBy });
    //gotoPage(0);
  }, [sortBy]);

  useEffect(() => {
    dispatch({ type: PAGE_FILTER_CHANGED, payload: props.filterObj });
    gotoPage(0);
  }, [gotoPage, props.searchClicked]);

  useEffect(() => {
    // let obj = {value:'email',}
    console.log("Chanigning");
    if (props.sortObj.selected) {
      setSortBy([
        { id: props.sortObj.sortFieldValue, desc: props.sortObj.sortDir },
      ]);
    } else {
      setSortBy([{ id: "id", desc: false }]);
    }

    // dispatch({ type: PAGE_SORT_CHANGED, payload: [{id:'firstName',desc:true}] });
  }, [gotoPage, props.sortObj.selected, props.sortObj.sortDir]);

  useEffect(() => {
    if (props.onChangeFilter == null || props.onChangeFilter == undefined) {
      dispatch({ type: PAGE_FILTER_CHANGED, payload: props.filterObj });
    }
  }, [props.filterObj]);

  useEffect(() => {
    dispatch({ type: PAGE_FILTER_CHANGED, payload: props.filterObj });
  }, [gotoPage, props.updateCurrentPage]);

  useEffect(() => {
    dispatch({ type: PAGE_FILTER_CHANGED, payload: props.filterObj });
  }, [
    props.updateCurrentPage == null || props.updateCurrentPage == undefined
      ? props.updateCurrentPage
      : null,
  ]);

  useEffect(() => {
    if (data?.count) {
      dispatch({
        type: TOTAL_COUNT_CHANGED,
        payload: data.count,
      });
    }
  }, [data?.count]);

  const handleChange = (e) => {
    console.log("tests");
    headerGroups[0].headers[3].getHeaderProps(
      headerGroups[0].headers[3].getSortByToggleProps()
    );
  };

  const setSelectedRowFunction = (cell) => {
    console.log("Row is ");
    console.log(cell);
    cell.original["index"] = cell.index;
    props.handleUserClick(cell.original);
  };

  const navigateUserToViewPage = (data) => {
    props.handleUserClick(data);
  };

  if (error) {
    return <p>Error</p>;
  }

  if (isLoading) {
    setLoaderRunning(true);
    // ref.current.continuousStart();
  }

  if (isSuccess) {
    ref.current.complete();
    return (
      <>
        <div className="main-container-list-view">
          <div className="parent-list-view">
            <div
              className="child-1-list-view"
              style={{ width: isMobile ? "100%" : "100%"}}
            >
              <table className="list-view-table" {...getTableProps()}>
                <thead style={{borderTop:"1px solid #3B3A39"}} className={`${!isMobile ? "list-view-thead" : ""}`}>
                  {headerGroups.map((headerGroup, i) => {
                    const { key, ...restHeaderGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr key={key} {...restHeaderGroupProps}>
                        {headerGroup.headers.map((column, j) => {
                          const { key, ...restColumn } =
                            column.getHeaderProps();
                          return (
                            <th
                              key={key}
                              {...column.getHeaderProps({
                                className: column.className,
                                style: column.headerStyle,
                              })}
                            >
                              {column.render("Header")}{" "}
                              {/* {column.sorting?column.isSorted ? <Sorting column={column} headerGroup={headerGroup} /> : 
                                           <Icon key={j} {...column.getHeaderProps(column.getSortByToggleProps())} iconName="Sort" className="ms-fontSize-12"></Icon>    
                                        :<></>                              
                                    } */}
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>

                <tbody
                  {...getTableBodyProps()}
                  className={`${
                    !isMobile ? "list-view-tbody modal-scroll" : "list-view-tbody modal-scroll"
                  }`}
                  
                >
                  {rows.length > 0 &&
                    rows.map((row, i) => {
                      prepareRow(row);
                      return (
                        <tr
                          className={`${!isMobile ? "list-view-tr" : ""}`}
                          style={{ borderBottom: "unset" }}
                          key={i}
                          {...row.getRowProps(
                            {
                              className: "hover-list-view-tr",
                              style:{
                                width:'100%'
                              }
                            }
                          )}
                        >
                          {row.cells.map((cell, i) => {
                            const { key, ...restCellProps } =
                              cell.getCellProps();
                            return (
                              <td
                                onClick={() => setSelectedRowFunction(cell.row)}
                                style={{
                                  cursor: "pointer",
                                  wordBreak: "break-all",
                                }}
                                key={key}
                                {...cell.getCellProps({
                                  className: cell.column.classChildName,
                                  style: cell.column.rowStyle,
                                })}
                              >
                                {cell.render("Cell")}
                              </td>
                            );
                          })}
                        </tr>
                      );
                      return <></>;
                    })}
                </tbody>
              </table>
            </div>
            {/* <div className="child-2-list-view" style={{width:isMobile?"100%":"50%",display:isMobile?"none":"flex"}}>
                <div
            style={{
              height: "100%",
              width: "100%",
              backgroundColor: "#161616"
            }}
          >
            <div style={{height:'88%'}}>
            {props.sideBarComponent}
            </div>
            <div style={{display:'flex',alignItem:'center',justifyContent:'end',marginRight:'10px'}}>
                <PrimaryButton onClick={()=>navigateUserToViewPage(props.selectedRowObj)} text="View User"/>
            </div>
            </div>
        </div> */}
          </div>

          {
            <>
              {typeof data?.count === "undefined" ||
                (data.count == 0 && (
                  <p style={{ textAlign: "center", paddingTop: "10px" }}>
                    {t("table.no-result-found")}
                  </p>
                ))}
            </>
          }
        </div>
        {rows.length > 0 && (
          <>
            <TablePagination
              page={page}
              gotoPage={gotoPage}
              previousPage={previousPage}
              nextPage={nextPage}
              canPreviousPage={canPreviousPage}
              canNextPage={canNextPage}
              pageOptions={pageOptions}
              pageSize={pageSize}
              pageIndex={pageIndex}
              pageCount={pageCount}
              setPageSize={setPageSize}
              manualPageSize={manualPageSize}
              dataLength={totalCount}
            />
            {/* <div className="pagination justify-content-end mt-2">
                            <span>
                            Go to page:{' '}
                            <input
                            type="number"
                                value={pageIndex + 1}
                                onChange={(e) => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                gotoPage(page);
                                }}
                                style={{ width: '100px' }}
                            />
                            </span>{' '}
                        </div> */}
          </>
        )}
      </>
    );
  }
};

export default ListViewTable;
